import memoizeOne from 'memoize-one';

import { getUseSharedWorker } from '../worker/canUseSharedWorker';

import { SharedWorkerImplementation } from './sharedWorker';
import { WebSocketImplementation } from './webSocket';

export const getSocketOrWorker = memoizeOne(
  async (): Promise<SharedWorkerImplementation | WebSocketImplementation> => {
    const useSharedWorker = await getUseSharedWorker();
    if (useSharedWorker) {
      const { sharedWorkerImplementation } = await import(
        './sharedWorkerImplementation'
      );
      return sharedWorkerImplementation;
    }
    const { websocketImplementation } = await import(
      './websocketImplementation'
    );
    return websocketImplementation;
  },
);
